export default {
  async authenticateByJWT(request: string, params = ''): Promise<string> {
    const token = await window.AP.context.getToken();
    return `${request}?jwt=${token}${params ? '&' + params : ''}`;
  },
};
